import serverCall from "../../serverCall";

const CreateColorCode = async (data) => {
  const response = await serverCall.post(
    `/race/create-color-code/admin`,data
  );
  return response;
};
const GetColorCode = async (id) => {
  const response = await serverCall.get(
    `/race/find-one-color-code/admin?colorCodeId=${id}`
  );
  return response;
};
const GetAllColorCode = async (page, limit, type) => {
  const response = await serverCall.get(
    `/race/find-color-code/admin?page=${page}&limit=${limit}&type=${type}`
  );
  return response;
};
const GetAllColorCodeSeasonName = async (type) => {
  const response = await serverCall.get(
    `/race/find-color-code/admin?type=${type}`
  );
  return response;
};
const GetSingleColorCode = async (id) => {
  const response = await serverCall.get(
    `/race/find-one-color-code/admin?colorCodeId=${id}`
  );
  return response;
};

const DeleteColorCode = async (id) => {
  const response = await serverCall.delete(
    `/race/delete-color-code/admin?colorCodeId=${id}`
  );
  return response;
};

const ColorCodeService = {
  CreateColorCode,
  GetAllColorCode,
  GetSingleColorCode,
  DeleteColorCode,
  GetColorCode,
  GetAllColorCodeSeasonName,
};

export default ColorCodeService;
